import Popup from "@/shared/components/layers/Popup/Popup";
import newcss from '../CreateCompanysPlanPopup/CreateCompanysPlanPopup.module.css';
import { Button } from "@/shared/components/common/Button/Button";
import CreateCompanysPlanPopup from '../CreateCompanysPlanPopup/CreateCompanysPlanPopup';
import { EditCompanysPlanPopupProps } from "./EditCompanysPlanPopup.model";
import { Input } from '@/shared/components/common/Input/Input';
import { Select } from '@/shared/components/common/Select/Select';
import { MONTH } from '@/shared/model/constants';
import useEditCompanysPlanPopup from './useEditCompanysPlanPopup';
import css from '../CreatePlanPopup/CreatePlanPopup.module.css';
import { ComboInputSelect } from "@/shared/components/common/ComboInputSelect/ComboInputSelect";
import { useEffect } from "react";


function EditCompanysPlanPopup(props: EditCompanysPlanPopupProps) {
  const { open, onClose, id } = props;
  const {
    form,
    users,
    departments,
    setInputValue,
    handleChange,
    loading,
    error,
    inputValue,
    options,
    dropdownValue,
    setDropdownValue,
    handleChangeTargetValue,
    handleRemoveFromMulty,
    selectedCompanies,
    planTypes,
    handleSave,
    handleDelete,
    setOpenCreatePopup,
    openCreatePopup,
    initForm
  } = useEditCompanysPlanPopup(id, onClose);

  if (!id) return null;

  return (
    <>
      <Popup open={open} onClose={onClose} title="Редактирование плана продаж по компаниям" size="xl">
        <form onSubmit={handleSave} className={`${css.actionPlanForm} ${newcss.actionPlanForm}`}>
          <div className={newcss.actionPlanFormActions} style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
            <Button type="button" onClick={
              () => setOpenCreatePopup(true)
              }>
              📋 Копировать
            </Button>
            <Button variant='danger' type="button" onClick={handleDelete}>
              🗑️ Удалить
            </Button>
          </div>
          <div className={css.actionPlanFormFields}>
            <div className={newcss.row}>
              <div className={newcss.actionPlanFormFieldRow}>
                <label className={newcss.actionPlanFormLabel}>Год:</label>
                <Input
                  type="number"
                  name="year"
                  min={new Date().getFullYear()}
                  value={form.year}
                  onChange={handleChange}
                  required
                />
              </div>
                <div className={newcss.actionPlanFormFieldRow}>
                  <label className={newcss.actionPlanFormLabel}>Месяц:</label>
                  <Select
                    name="month"
                    value={form.month ? String(form.month) : ''}
                    onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                    options={[
                      { value: '', label: 'Выберите месяц' },
                    ...MONTH.map((m, idx) => ({ value: String(idx + 1), label: m })),
                  ]}
                />
              </div>
            </div>
            <div className={newcss.row}>
              <div className={newcss.actionPlanFormFieldRow}>
                <label className={newcss.actionPlanFormLabel}>Подразделение:</label>
                <Select
                  name="department_id"
                  value={form?.department_id ? String(form.department_id) : ''}
                  onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                  required
                  options={[
                    { value: '', label: 'Выберите подразделение' },
                    ...(departments ? departments.map(d => ({ value: String(d.id), label: d.name })) : []),
                  ]}
                  loading={loading.departments}
                  error={error.departments ? 'Ошибка загрузки подразделений' : undefined}
                  loadingText="Загрузка подразделений..."
                  errorText={
                    error.departments
                      ? 'Ошибка загрузки подразделений'
                      : (!loading.departments && departments.length === 0)
                      ? 'Нет доступных подразделений'
                      : undefined
                  }
                />
              </div>
              <div className={newcss.actionPlanFormFieldRow}>
                <label className={newcss.actionPlanFormLabel}>Исполнитель:</label>
                <Select
                  name="user_id"
                  value={form?.user_id ? String(form.user_id) : ''}
                  onChange={(value, name) => handleChange({ target: { name, value } } as any)}
                  required
                  options={[
                    { value: '', label: 'Выберите исполнителя' },
                    ...(users ? users.map(u => ({ value: String(u.id), label: `${u.name} ${u.last_name}` })) : []),
                  ]}
                  loading={loading.users}
                  error={error.users ? 'Ошибка загрузки сотрудников' : undefined}
                  loadingText="Загрузка сотрудников..."
                  errorText={
                    error.users
                      ? 'Ошибка загрузки сотрудников'
                      : (!loading.users && users.length === 0)
                      ? 'Нет доступных сотрудников'
                      : undefined
                  }
                />
              </div>
            </div>
            <ComboInputSelect
              inputValue={inputValue}
              setInputValue={setInputValue}
              dropdownList={options}
              dropdownValue={dropdownValue || []}
              setDropdownValue={setDropdownValue}
              loading={loading.companies}
              multiple={true}
              placeholder="Начните вводить ИНН или название компании..."
            />
            {form.multy && form.multy.length > 0 && form.multy.map((item) => (
              <div key={item.object} className={newcss.actionPlanFormFieldRowCompany} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <label className={newcss.actionPlanFormCompanyLabel}>
                  {selectedCompanies.find(c => c.inn === item.object)?.label || item.object} ({item.object})
                </label>
                <div className={newcss.actionPlanFormCompanyInputs}>
                  {planTypes && planTypes.length > 0 && planTypes.map(pt => (
                    <div key={pt.id}>
                      <Input
                        type="number"
                        name={`target_value_${item.object}_${pt.id}`}
                        label={pt.plan_object ?? ''}
                        value={item.target_values.find(tv => tv.plan_type_id === pt.id)?.target_value || ''}
                        onChange={e => handleChangeTargetValue(item.object, pt.id, Number(e.target.value))}
                        min={1}
                        placeholder="Целевое значение"
                      />
                    </div>
                  ))}
                <button
                type="button"
                aria-label="Удалить компанию"
                onClick={() => handleRemoveFromMulty(item.object)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, marginLeft: 4 }}
                >
                ❌
                </button>
                </div>
              
              </div>
            ))}
          </div>
          <div className={css.actionPlanFormSubmitWrapper}>
            <Button variant='success' type="submit" disabled={loading.users || loading.departments || loading.companies}>
              Сохранить
            </Button>
          </div>
        </form>
      </Popup>
      {openCreatePopup && (
        <CreateCompanysPlanPopup open={openCreatePopup} onClose={() => setOpenCreatePopup(false)} initialData={form ?? initForm} />
      )}
    </>
  );
}

export default EditCompanysPlanPopup; 